<template>
  <div class="h-screen flex">
    <!-- Left Side (Form) -->
    <div class="w-1/2 flex flex-col justify-center px-16 bg-base-100">
      <div class="max-w-md mx-auto w-full">
        <img src="/img/big_full_logo.svg" alt="Logo" class="h-10 mb-8"/>
        <h1 class="text-3xl font-bold mb-2">Log in</h1>
        <p class="text-base-content mb-6">Welcome back! Please enter your details.</p>
        <LoginForm v-model:email="data.email" v-model:password="data.password" :loading="loading"
                   @submit="handleLogin"/>
        <!-- DaisyUI alert for unauthorized login -->
        <transition name="fade">
          <div v-if="error" class="alert alert-error mt-4 animate-fade-in">
            <span>{{error}}</span>
          </div>
        </transition>
        <p class="text-center mt-6 text-sm">
          Don't have an account? <a href="#" class="text-error font-medium">Contact us</a>
        </p>
        <footer class="mt-16 text-xs text-base-content/70">
          &copy; CharterPlace 2026
          <span class="ml-2 text-base-content/40">v{{ appVersion }}</span>
        </footer>
      </div>
    </div>

    <!-- Right Side (Visual) -->
    <div class="w-1/2 bg-primary text-primary-content relative flex items-center justify-start ps-16">
      <img src="/img/plane_login.svg" alt="Background Image" class="absolute top-0 left-0 w-full h-full object-cover" style="z-index: 0"/>
      <div class="text-left max-w-md px-6" style="z-index: 1">
        <p class="uppercase text-error text-md mb-2">SaaS Platform</p>
        <h2 class="text-6xl font-bold leading-tight">A Powerful Solution for Every Player</h2>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue'
import {useAuthStore} from "@/stores"
import {useRoute, useRouter} from 'vue-router'
import LoginForm from "@/components/organisms/LoginForm.vue"

const appVersion = __APP_VERSION__

const data = ref({
  email: '',
  password: ''
})
const error = ref('')
const loading = ref(false)

const auth = useAuthStore()
const router = useRouter()
const route = useRoute()

async function handleLogin() {
  error.value = ''
  loading.value = true
  try {
    await auth.login(data.value)
    const redirectTo = route.query.redirect || '/'
    await router.push(redirectTo)
  } catch (err) {
    error.value = 'Invalid username or password'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
